import type { CardCandidate } from './types'

const fields = [
  ['name', 'Player / card name'], ['sport', 'Sport'], ['releaseYear', 'Year'],
  ['manufacturer', 'Manufacturer'], ['setName', 'Set'], ['collectorNumber', 'Card number'],
  ['parallelName', 'Parallel / variant'], ['gradingCompany', 'Grading company'],
  ['grade', 'Grade'], ['certificationNumber', 'Certification number'],
] as const

export function SportsDetailsEditor({ card, onChange }: {
  card: CardCandidate
  onChange: (card: CardCandidate) => void
}) {
  return <section className="sports-review" aria-label="Review sports card details">
    <p className="muted">Check these details before saving. OCR and seller titles are suggestions; grades and certification numbers must match your own card.</p>
    {card.sportsScanImageUrl && <img className="sports-scan-reference" src={card.sportsScanImageUrl} alt="Your scanned card for comparison" />}
    <div className="edit-grid">
      {fields.map(([key, label]) => <label key={key}>{label}
        <input value={card[key] ?? ''} onChange={event => onChange({ ...card, [key]: event.target.value })} />
      </label>)}
    </div>
  </section>
}
